const cantPowerUpTokenModal = {
    container: `absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[8px] bg-white max-w-[400px] text-black w-full
                sm:min-w-[300px] overflow-hidden
    `,
    imageBackground: `relative rounded-b-[50%] h-[100px] bg-primaryHeading`,
    imageContainer: `absolute -bottom-10 left-1/2 -translate-x-1/2`,
    image: `flex items-center justify-center w-full h-[auto] max-w-[108px]`,
    innerContainer: `flex flex-col gap-[11px] justify-center items-center text-center p-[25px] pt-[40px]`,
    closeButton: `absolute top-2 right-2 text-white`,
    heading: `text-[27px] font-Suisse text-primaryHeading leading-[20px]`,
    
}

export { cantPowerUpTokenModal }